import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Connections, TestConnectionReturn } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ConnectionsService extends TmsWebBaseEditService<Connections, Connections> {
  constructor() {
    super('Connections', $localize`Connections`);
  }

  testConnection(id: string, counter: number): Observable<TestConnectionReturn> {
    return this.httpService.post<TestConnectionReturn>(`${this.apiUrl}/TestConnection`, { id, counter });
  }
}
